<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="cancelEvent.emit()">
            <img src="assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_menu_styles" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div *ngIf="isLogo.value" class="form-group mb-20">
            <label class="col-xs-12">
                {{ "control_logo_position" | translate }}
            </label>
            <div class="col-xs-12">
                <sp-radio-group
                    [selected]="logoPosition.value"
                    [type]="ERadioGroupType.logoPosition"
                    (changeSelectedEvent)="setlogoPosition($event)"
                ></sp-radio-group>
            </div>
        </div>

        <div class="form-row mb-20">
            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_menu_items_position" | translate }}
                </label>
                <div class="col-xs-7">
                    <sp-radio-group
                        [selected]="layoutDirection.value"
                        [type]="ERadioGroupType.menu"
                        (changeSelectedEvent)="setLayoutDirection($event)"
                    ></sp-radio-group>
                </div>
                <div class="col-xs-5">
                    <sp-radio-group
                        [selected]="horizontalPosition.value"
                        [type]="ERadioGroupType.horizontalPosition"
                        (changeSelectedEvent)="setHorizontalPosition($event)"
                    ></sp-radio-group>
                </div>
            </div>

            <div class="form-group">
                <label class="col-xs-6 control-label">
                    {{ "control_content_indent" | translate }}
                </label>
                <div class="col-xs-6">
                    <sp-radio-group
                        [selected]="menuItemIndent.value"
                        [type]="ERadioGroupType.size"
                        (changeSelectedEvent)="setMenuItemIndent($event)"
                    ></sp-radio-group>
                </div>
            </div>

            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_text_style" | translate }}
                </label>
                <div class="col-xs-4">
                    <sp-input-num
                        suffixText="px"
                        [max]="FONT_SIZE_MAX"
                        [value]="fontSize.value"
                        (valueChange)="setFontSize($event)"
                    ></sp-input-num>
                </div>
                <div class="col-xs-6">
                    <div class="btn-group btn-group-justified" data-toggle="buttons">
                        <label
                            class="btn btn-grey active"
                            [class.active]="isActiveTextStyle(EFontStyle.AT)"
                            (click)="toggleActiveTextStyle(EFontStyle.AT)"
                        >
                            <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                        </label>

                        <label
                            class="btn btn-grey"
                            [class.active]="isActiveTextStyle(EFontStyle.B)"
                            (click)="toggleActiveTextStyle(EFontStyle.B)"
                        >
                            <img src="./assets/img/lpc-icon-bold.svg" alt="B" />
                        </label>

                        <label
                            class="btn btn-grey"
                            [class.active]="isActiveTextStyle(EFontStyle.I)"
                            (click)="toggleActiveTextStyle(EFontStyle.I)"
                        >
                            <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                        </label>
                    </div>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="textColor.value"
                        (colorChangeEvent)="setTextColor($event)"
                    ></web-color-picker>
                </div>
            </div>

            <web-hover-effects [effects]="hoverEffects"></web-hover-effects>
        </div>
    </div>

    <hr class="panel-options-divider mb-15" />

    <div class="form form-horizontal">
        <div class="form-row mb-20">
            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_submenu_text_style" | translate }}
                </label>
                <div class="col-xs-4">
                    <sp-input-num
                        suffixText="px"
                        [max]="FONT_SIZE_MAX"
                        [value]="submenuFontSize.value"
                        (valueChange)="setSubmenuFontSize($event)"
                    ></sp-input-num>
                </div>
                <div class="col-xs-6">
                    <div class="btn-group btn-group-justified" data-toggle="buttons">
                        <label
                            class="btn btn-grey active"
                            [class.active]="isActiveSubmenuTextStyle(EFontStyle.AT)"
                            (click)="toggleActiveSubmenuTextStyle(EFontStyle.AT)"
                        >
                            <img src="./assets/img/lpc-icon-uppercase.svg" alt="AT" />
                        </label>

                        <label
                            class="btn btn-grey"
                            [class.active]="isActiveSubmenuTextStyle(EFontStyle.B)"
                            (click)="toggleActiveSubmenuTextStyle(EFontStyle.B)"
                        >
                            <img src="./assets/img/lpc-icon-bold.svg" alt="B" />
                        </label>

                        <label
                            class="btn btn-grey"
                            [class.active]="isActiveSubmenuTextStyle(EFontStyle.I)"
                            (click)="toggleActiveSubmenuTextStyle(EFontStyle.I)"
                        >
                            <img src="./assets/img/lpc-icon-italic.svg" alt="I" />
                        </label>
                    </div>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="submenuTextColor.value"
                        (colorChangeEvent)="setSubmenuTextColor($event)"
                    ></web-color-picker>
                </div>
            </div>

            <div class="form-group">
                <label class="col-xs-10 control-label">
                    {{ "control_submenu_background" | translate }}
                </label>
                <div class="col-xs-2">
                    <web-color-picker
                        [hideGradient]="true"
                        [color]="submenuListBackground.value"
                        (colorChangeEvent)="setSubmenuListBackground($event)"
                    ></web-color-picker>
                </div>
            </div>
        </div>
    </div>

    <hr class="panel-options-divider mb-15" />

    <div class="form form-horizontal">
        <div class="form-row">
            <div [ngClass]="{ 'mb-10': showIconOnMobile.value }" class="form-group">
                <label class="col-xs-9 control-label">
                    {{ "control_show_menu_icon_on_mobile" | translate }}
                </label>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch [active]="showIconOnMobile.value" (toggleActiveEvent)="toggleIconOnMobile($event)">
                    </sp-switch>
                </div>
            </div>

            <div *ngIf="showIconOnMobile.value" class="form-group">
                <label class="col-xs-12">
                    {{ "control_position_and_style_icon" | translate }}
                </label>
                <div class="col-xs-4">
                    <sp-radio-group
                        [selected]="iconPosition.value"
                        [type]="ERadioGroupType.faqIconPosition"
                        (changeSelectedEvent)="setIconPosition($event)"
                    ></sp-radio-group>
                </div>
                <div class="col-xs-6">
                    <sp-radio-group
                        [selected]="iconSize.value"
                        [type]="ERadioGroupType.size"
                        (changeSelectedEvent)="setIconSize($event)"
                    ></sp-radio-group>
                </div>
                <div class="col-xs-2">
                    <web-color-picker
                        [color]="iconColor.value"
                        (colorChangeEvent)="setIconColor($event)"
                    ></web-color-picker>
                </div>
            </div>
        </div>
    </div>
</div>
<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
